import { styled } from "styled-components";
import { AnalyticsContainerIntro } from "../../Pages/DashboardStyle";

export const LeaderboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    padding-top: 5%;
    height: 100%;
    flex-grow: 1;
    align-items: center;
    overflow-x: hidden;
    animation: ${AnalyticsContainerIntro}
        ${(props) => props.theme.animationTime.medium}s;

    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        width: 100%;
        padding-top: 10%;
    }
`;

export const LeaderBoardTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;
    font-size: 35px;
    font-weight: 600;
    text-transform: uppercase;
    height: 50px;
    margin-bottom: 5%;
    border-bottom: 1px solid ${(props) => props.theme.colors.accentMain};
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        font-size: 25px;
    }
`;

interface MenuBarProps {
    $active: boolean;
}

export const LeaderboardMenuBar = styled.div<MenuBarProps>`
    position: relative;
    display: flex;
    justify-content: space-around;
    width: 100%;
    font-weight: 600;
    text-transform: uppercase;
    padding-top: 1%;
    padding-bottom: 1%;
    left: ${(props) => (props.$active ? "0" : "-2000px")};
    transition: 500ms all ease;
`;

export const LeaderboardMenuOption = styled.div`
    padding: 1%;
`;

export const LeaderboardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-weight: 600;
    text-transform: uppercase;
    border-bottom: 1px solid ${(props) => props.theme.colors.accentMain};
    padding-bottom: 5%;
    padding-top: 5%;
`;

export const LeaderboardHeaderItem = styled.div`
    padding-left: 5%;
    padding-right: 5%;
`;

export const LeaderboardList = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    vertical-align: top;
`;

export const LeaderboardUser = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.accentMain};
    padding: 8px;
    font-weight: 600;
`;

export const LeaderboardUserCard = styled.div`
    height: 0;
`;

export const LeaderboardUserImage = styled.img`
    width: 35px;
    height: 35px;
    border-radius: 50%;
`;
export const LeaderboardUserImageAndName = styled.div`
    display: flex;
    align-items: center;
    width: 30%;
    padding-left: 5%;
`;
export const LeaderboardUserName = styled.div`
    padding-left: 20px;
`;

export const LeaderboardUserLevel = styled.div`
    padding-right: 5%;
`;

export const MenuBurgerHolder = styled.div`
`;
